import { Record } from '@common/data-models/records/record';
import { SingleViewStateRecord } from '@common/data-models/records/single-viewstate-record';
import { ViewStateTypes } from "@common/enums/viewstate-types";
import { ObjectTypes } from "@common/enums/object-types";
import { ViewStateLayouts } from "@common/enums/viewstate-layouts";
import { ViewStateOptions } from "@common/data-models/navigation/viewstate-options";
import { PSTFieldNames } from "@common/data-models/fields/pst-field-names";
import { ViewStateFilterSerializer, ViewStateOptionsSerializer } from "@common/data-models/serializers/serializers";
import { GlobalTablesService } from "@common/services/global-tables-service";

export class DraftViewStateRecord extends SingleViewStateRecord {
    
    public initialize() {
        this.viewStateType = ViewStateTypes.DRAFT;
        super.initialize();
        this.viewStateLayout = ViewStateOptionsSerializer.Instance(Record.globalTablesService).initialize(this.viewStateType, PSTFieldNames.PSTViewStateLayout);
    }
    
    public get viewStateLayout(): ViewStateOptions { return this.getAs<ViewStateOptions>("PSTViewStateLayout"); }
    public set viewStateLayout(value: ViewStateOptions) { this.set("PSTViewStateLayout", value); }
}
